import NetworkLogic from "../../Shared/NetworkLogic";
import Player from "../../Models/Player";
import UIManager from "../../Shared/UIManager";
import { Global } from "../../Shared/Global";
import AudioManager from "../../Shared/AudioManager";
import HallUI from "../HallUI";
import SignData from "./SignData";
import PopWindowManager from "../../Shared/PopWindowManager";
import find = cc.find;
import Utils from "../../Shared/Utils";
const i18n = require('LanguageData');
const { ccclass, property } = cc._decorator;

@ccclass
export default class SignInPop extends cc.Component {

    @property([cc.Node])
    itemArr: cc.Node[] = [];
    @property(cc.Button)
    btnLingqu: cc.Button = null;
    @property(cc.Prefab)
    baoxiangPrefab: cc.Prefab = null;
    @property(cc.ScrollView)
    scrollV: cc.ScrollView = null;

    @property(cc.Label)
    labBottom: cc.Label = null;
    @property(cc.Node)
    content: cc.Node = null;
    @property([cc.SpriteFrame])
    iconArr: cc.SpriteFrame[] = [];

    private openNext = true;
    bCanSign = false;

    onLoad() {


    }
    /**
     explain: "签到送钱，啦啦啦11"
     signData: Array(3)
     0:
     id: ""
     day: 1
     vip: 1
     signMoney: 1
     signImg: "http://api.fanyirong.com:8080/group1/zonghe/6345aafc4be9518f8b7179a683d2f179.jpg"
     auditMultiple: 0
     status: ""
     signCount: ""
     signCountTotal: ""
     getAmount: ""
     getAmountTotal: ""
     whetherNotSignIn: 0   0 已签到，1可签到，2，未签到
     */
    start() {
        SignData.getSignData().then(value => {
            this._updateUI(value)

        });
    }

    // updateUI() {
    //     //弹窗签到的重新写一个脚本；
    //     UIManager.showLoadingUI();
    //     SignData.getSignData().then(value => {
    //         UIManager.hideLoadingUI();
    //         this._updateUI(value)
    //     });
    //
    //
    // }

    _updateUI(rec) {
        let signData = rec.signData;
        this.labBottom.string = rec.explain;
        this.content.destroyAllChildren();
        for (let i = 0; i < signData.length; i++) {
            let day = (signData[i].day - 1) % 7;
            cc.log("===signData[i].day:", signData[i].day)
            cc.log(day);
            let item = cc.instantiate(this.itemArr[day]);
            item.parent = this.content;
            item.active = true;
            let itemChild = item.getChildByName(this._getNameByWhetherNotSignIn(signData[i].whetherNotSignIn))
            itemChild.active = true;
            itemChild.getChildByName("num_label").getComponent(cc.Label).string = signData[i].day + i18n.t('BasicsJS.day');
            itemChild.getChildByName("labMoney").getComponent(cc.Label).string = Global.currencySymbol + signData[i].signMoney ;
            item.getChildByName("icon").getComponent(cc.Sprite).spriteFrame = this.iconArr[i % 4];
            item.getChildByName("spYes").active = (signData[i].whetherNotSignIn === 0);//已签到
            item["iconUrl"] = signData[i].signImg;
            item["signData"] = signData[i];
        }
        for (let i = 0; i < signData.length; i++) {
            if (signData[i].whetherNotSignIn === 1) {//可签到
                this.bCanSign = true;
                let maxScrollOffset = this.scrollV.getMaxScrollOffset();
                let offset = maxScrollOffset.y / signData.length * (i + 1);
                this.scrollV.scrollToOffset(cc.v2(0, offset), 0.1);
                break;
            }
        }
        for (let i = 0; i < this.content.children.length; i++) {
            let item = this.content.children[i];
            this.getIcon(item["signData"].signImg, item);
        }
        if (!this.bCanSign) {
            this.btnLingqu.interactable = false;
        }
        cc.log("===signData", signData);
    }

    _getNameByWhetherNotSignIn(whetherNotSignIn) {
        switch (whetherNotSignIn) {
            case 0:
                return "spYilingqu";
                break;
            case 1:
                return "spCan";
                break;
            case 2:
                return "spCannt";
                break;
        }
    }

    getIcon(url, item) {
        cc.loader.load(url, function (err, texture) {
            if (!err && this.node) {
                if (cc.isValid(item))
                    item.getChildByName("icon").getComponent(cc.Sprite).spriteFrame = new cc.SpriteFrame(texture);
            } else {

            }
        }.bind(this))
    }

    // touchEndDay(event,param){
    //     AudioManager.playSound("button");
    //     let target = event.currentTarget;
    //     let lp = target.convertToNodeSpaceAR(event.getLocation());
    //     if (!cc.Intersection.pointInPolygon(lp, target.getComponent(cc.PolygonCollider).points)) {
    //         cc.log("===点击外部区域");
    //         return;
    //     }
    //     NetworkLogic.signInSign({},function (rec) {
    //         cc.log("====签到成功rec：",rec);
    //         target.getChildByName("spH").active = false;
    //         target.getChildByName("spYes").active = true;
    //         cc.director.emit(Global.UserEvent.UpdateMoney);
    //         cc.director.emit(Global.UserEvent.OpenBaoxiang,target.param);
    //
    //         //签到之后弹金币动画，所以暂时不弹后面的
    //         this.openNext = false;
    //         SignData.resetSignData() ;//领取之后重置数据
    //         target.off(cc.Node.EventType.TOUCH_END);
    //         this.onBtnClose();
    //     }.bind(this),function () {
    //         cc.log("=====签到错误");
    //     }.bind(this));
    // }

    onBtnLingqu(event, param) {
        Utils.disable_btn_sec(event,5)
        let target = null;

        for (let i = 0; i < this.content.children.length; i++) {
            let item = this.content.children[i];
            if (item["signData"].whetherNotSignIn === 1) {//可签到
                target = item;
                break;
            }
        }
        NetworkLogic.signInSign({}, function (rec) {
            cc.log("====签到成功rec：", rec);
            target.getChildByName("spYes").active = true;
            this.btnLingqu.interactable = false;
            cc.director.emit(Global.UserEvent.UpdateMoney);
            cc.director.emit(Global.UserEvent.OpenBaoxiang, target["signData"].signMoney);
            //签到之后弹金币动画，所以暂时不弹后面的
            this.openNext = false;
            SignData.resetSignData();//领取之后重置数据
            this.onBtnClose();
        }.bind(this), function () {
            cc.log("=====签到错误");
        }.bind(this));
    }

    onBtnClose(event, param, bPlay = true) {
        bPlay && AudioManager.playSound("close");

        if (this.openNext)//开宝箱则不弹下一个窗口
            PopWindowManager.openNext()
        this.node.destroy();
    }

    onDestroy(): void {

    }
}
